
export const locale = {
  lang: "en",
  data: {
    "ButtonTitle": "OK",
  }
};
